import React, { useEffect, useState } from 'react';
import { HiOutlineClock } from 'react-icons/hi';
import { contactsData } from '../../../data/contactsData';
import { certificationsData, educationData } from '../../../data/educationData';
import { experienceData } from '../../../data/experienceData';
import { headerData } from '../../../data/headerData';
import { formatClock } from '../../../utils/timeZone';
import Reveal from '../../helper/reveal';
import './glance.css';

// Re-renders once a minute so the clock stays right without a busy timer.
function useNow() {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        let timeout;
        const tick = () => {
            setNow(new Date());
            timeout = setTimeout(tick, 60000 - (Date.now() % 60000) + 50);
        };
        timeout = setTimeout(tick, 60000 - (Date.now() % 60000) + 50);
        return () => clearTimeout(timeout);
    }, []);
    return now;
}

function Glance() {
    const now = useNow();
    const current = experienceData[0];
    const degree = educationData[0];

    let clock = null;
    try {
        clock = {
            time: formatClock(now, headerData.timezone),
        };
    } catch (e) {
        clock = null; // Intl time zones unavailable: the cell just omits the clock
    }

    return (
        <section className='glance' aria-label='At a glance'>
            <Reveal className='container'>
                <dl className='glance__grid'>
                    <div className='glance__cell'>
                        <dt>Currently</dt>
                        <dd>
                            {headerData.role}
                            <span>{current.company}, since {current.startYear}</span>
                        </dd>
                    </div>

                    <div className='glance__cell'>
                        <dt>Based in</dt>
                        <dd>
                            {contactsData.address}
                            {clock && (
                                <span className='glance__clock'>
                                    <HiOutlineClock aria-hidden='true' />
                                    <time dateTime={now.toISOString()}>{clock.time}</time>
                                </span>
                            )}
                        </dd>
                    </div>

                    <div className='glance__cell'>
                        <dt>Experience</dt>
                        <dd>
                            {headerData.experience}
                            <span>Full-stack, backend and applied AI</span>
                        </dd>
                    </div>

                    <div className='glance__cell'>
                        <dt>Education</dt>
                        <dd>
                            B.Sc. Software Engineering
                            <span>{degree.institution}, {degree.detail}</span>
                        </dd>
                    </div>

                    <div className='glance__cell'>
                        <dt>Languages</dt>
                        <dd>{headerData.languages}</dd>
                    </div>

                    <div className='glance__cell'>
                        <dt>Training</dt>
                        <dd>
                            {certificationsData.length} courses and certificates
                            <span>Udacity, Coursera, freeCodeCamp, Jimma University</span>
                        </dd>
                    </div>
                </dl>
            </Reveal>
        </section>
    );
}

export default Glance;
